import { Injectable } from '@angular/core';
import { Tool } from '@trimble-agentic-external-npm-local/agentic-platform-sdk-iframe-typescript';
import { ApplyFilterTool } from './tools/apply-filter.tool';
import { LogPromptTool } from './tools/log-prompt.tool';
import { SelectFeaturesTool } from './tools/select-features.tool';
import { ZoomToLayerTool } from './tools/zoom-to-layer.tool';

/**
 * Interface for runtime tool configuration used by the AI agent
 */
export interface RuntimeToolConfig {
    definition: Tool;
    callback: (params: any) => Promise<string>;
    timeOutInMs: number;
}

/**
 * Service that provides AI agent tools for interacting with the map viewer.
 * Add new tool definitions and callbacks here to extend agent capabilities.
 */
@Injectable({
    providedIn: 'root'
})
export class AiAgentToolsService {
    constructor(
        private zoomToLayerTool: ZoomToLayerTool,
        private applyFilterTool: ApplyFilterTool,
        private logPromptTool: LogPromptTool,
        private selectFeaturesTool: SelectFeaturesTool
    ) {}

    // ============================================
    // PUBLIC API
    // ============================================

    /**
     * Returns all runtime tools configuration for the AI agent.
     * This is used by the contextBeforeRun callback.
     */
    public getRuntimeTools(): { [toolName: string]: RuntimeToolConfig } {
        return {
            zoom_to_layer: {
                definition: this.zoomToLayerTool.definition,
                callback: (params: { layer_id: string }) => this.zoomToLayerTool.execute(params),
                timeOutInMs: 10000
            },
            apply_filters: {
                definition: this.applyFilterTool.definition,
                callback: async params => {
                    return this.applyFilterTool.execute(params);
                },
                timeOutInMs: 10000
            },
            log_prompt: {
                definition: this.logPromptTool.definition,
                callback: (params: { user_prompt: string }) => this.logPromptTool.execute(params),
                timeOutInMs: 5000
            },
            select_features: {
                definition: this.selectFeaturesTool.definition,
                callback: (params: { feature_ids: string[]; action?: string; zoom_to_features?: boolean }) =>
                    this.selectFeaturesTool.execute(params as any),
                timeOutInMs: 10000
            }
        };
    }
}
